export function useCountry() {
  const language = window.location.pathname.split('/')[1];

  if (language.startsWith('nl')) return 'nl';
  if (language.startsWith('de')) return 'de';

  return '';
}
